
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import vueWaterfallEasy from "src/utils/vue-waterfall-easy/vueWaterfallEasy";
import { Toast } from "vant";
import { StoreProductService, LocationcityService } from "src/services";
import { setColorOpacity } from "src/utils/extends";
import { Empty } from "vant";

@Component({
  components: { vueWaterfallEasy },
})
export default class ProductGroup extends Vue {
  // 用于刷新子组件
  private keyNum: any = 0;

  // 样式
  private pageStyle: any = {};

  /**
   * 父组件传值
   * @private
   * @returns object
   */
  @Prop({ type: Object, default: {} })
  private data: {};

  // 父组件传值

  // 产品类型列表
  private productTypeList: any = [];

  // 可选产品类型
  private optionalProductType: any = -1;

  /**
   * 当前页码
   */
  private pageIndex: number = 0;

  /**
   * 当前页码
   */
  private loading: boolean = false;

  /**
   * 选中位置
   * @private
   * @returns any
   */
  private get currentLocaltion(): any {
    return this.$store.getters.currentLocaltion;
  }

  /**
   * 当前位置
   * @private
   * @returns any
   */
  private get location(): any {
    return this.$store.getters.location;
  }

  /**
   * 查询关键词
   * @private
   * @returns any
   */
  private get searchKey(): any {
    return this.$store.getters.searchKey;
  }

  /**
   * 查询关键词
   * @private
   * @returns any
   */
  private get styleVars(): any {
    if ((this.data as any).properties.moduleSettings.imgCorner) {
      return {
        "--borderRadius": 0,
        "--menu-color": (this.data as any).properties.moduleSettings.menuColor || "#3BC4A9",
        "--menu-bg-color": (this.data as any).properties.moduleSettings.menuColor
          ? setColorOpacity((this.data as any).properties.moduleSettings.menuColor, 0.14)
          : "rgba(59, 196, 169, 0.14)",
      };
    } else {
      return {
        "--borderRadius": "6px",
        "--menu-color": (this.data as any).properties.moduleSettings.menuColor || "#3BC4A9",
        "--menu-bg-color": (this.data as any).properties.moduleSettings.menuColor
          ? setColorOpacity((this.data as any).properties.moduleSettings.menuColor, 0.14)
          : "rgba(59, 196, 169, 0.14)",
      };
    }
  }

  /**
   * 商品列表
   * @private
   * @returns void
   */
  private products: Array<any> = [];

  /**
   * 获取产品类型列表
   * @protected
   */
  protected async getStoreProductType(): Promise<void> {
    try {
      let cityName = this.currentLocaltion || this.location?.city;
      let { content: result } = await StoreProductService.instance.getStoreProductType(cityName);

      if (result.data) {
        this.productTypeList = result.data;
        let showAllGroup = (this.data as any).properties.moduleSettings.showAllGroup;
        this.optionalProductType = showAllGroup ? "-1" : result.data[0]?.productType;
      }
    } catch (err) {
      Toast(err);
    }
  }

  /**
   * 获取商品数据列表
   */
  protected async loadData(parameter: any): Promise<any> {
    this.loading = true;
    let optionalProductType = null;
    if (this.optionalProductType != -1) {
      optionalProductType = this.optionalProductType;
    }

    try {
      this.pageIndex++;
      parameter = {
        pageIndex: this.pageIndex,
        pageSize: 10,
      };

      let { content: res } = await StoreProductService.instance.getStoreProduct(
        Object.assign(
          {
            productType: optionalProductType,
            key: this.searchKey || "",
            cityName: this.currentLocaltion || this.location?.city,
          },
          parameter
        )
      );

      let productListData = res.data;
      if (res.data.totalPages == 0) {
        (this.$refs.waterfall as any).waterfallOver();
      } else {
        if (res.data.items) {
          this.products = this.products.concat(productListData.items);
          this.products.forEach((p) => (p.src = ""));
        }

        if (this.pageIndex == res.data.totalPages) {
          setTimeout(() => {
            (this.$refs.waterfall as any).waterfallOver();
          }, 1);
        }
      }

      this.loading = false;
      return res.data;
    } catch (err) {
      Toast(err);
      this.loading = false;
    }
  }

  /**
   * 点击分类
   */
  protected onCategoryClick(type: number): void {
    let dom = document.querySelector("#product-type-ul") as any;
    let waterfallDom = document.querySelector(".vue-waterfall-easy") as any;
    if (waterfallDom) {
      waterfallDom.style.minHeight = window.innerHeight - dom?.getBoundingClientRect().top - 40 + "px";
    }

    if (this.loading) {
      return;
    }
    this.optionalProductType = type;
    this.onRefresh();
  }

  /**
   * 搜索
   */
  protected onRefresh(isAll: boolean = false): void {
    // 产品
    if (this.previvewModule == 0 || isAll) {
      this.products = [];
      this.pageIndex = 0;
      (this.$refs.waterfall as any).reset();
      this.loadData({});
    }
    // 机构
    if (this.previvewModule == 1 || isAll) {
      this.packageObj = {};
      this.hospitalDataList = [];
      this.hospitalState.pageIndex = 0;
      (this.$refs.waterfallHospital as any).reset();
      this.loadDataHospital({});
    }
  }

  /**
   * 套餐详情
   * @private
   * @type 体检类型
   * @returns void
   */
  private onPhysicalPackage(item: any, pData?: any): any {
    // 体检套餐 PhysicalPackage = 0
    // 医疗服务 MedicalService = 2
    // 实物 Goods = 4
    // 健管服务 HealthManageService = 6
    // 问诊购药 DiagMedicine = 2002
    // 就医绿通 Greenway = 2004
    // 齿科服务 Dental = 2006
    // 眼科服务 Eye = 2008
    // 疫苗服务 Vaccine = 2010
    // 中医服务 TCM = 2012
    // 轻医美 MedicalBeauty = 2014

    if (item.productType == 0) {
      // 体检套餐
      this.$router.push({
        name: "package-detail",
        query: { id: item.targetId, productId: item.id, hospitalId: pData?.id },
      });
    } else if (item.productType == 4) {
      // 实物套餐
      this.$router.push({
        name: "goodsDetail",
        query: { id: item.targetId, productId: item.id, hospitalId: pData?.id },
      });
    } else if (item.productType == 8) {
      // 健康险产品
      this.$router.push({ name: "healthInsuranceDetail", query: { id: item.targetId, hospitalId: pData?.id } });
    } else {
      this.$router.push({ name: "medical", query: { id: item.targetId, productId: item.id, hospitalId: pData?.id } });
    }
  }

  /**
   * 组件创建钩子
   */
  protected async created() {
    this.previvewModule = (this.data as any).properties.moduleSettings?.moduleIds?.length
      ? (this.data as any).properties.moduleSettings.previvewModule
      : 0;
    await this.getStoreProductType();
    await this.loadData({});

    if ((this.data as any).properties.moduleSettings?.moduleIds.includes(1)) {
      this.getCityArea();
      this.loadDataHospital({});
    }
  }

  /**
   * 值发生变化
   * @protected
   * @returns void
   */
  @Watch("data", { immediate: true, deep: true })
  private onDataChange(newValue: any): void {
    this.pageStyle = {
      "margin-top": newValue.properties.moduleSettings.upAndDown + "px",
      "background-color": newValue.properties.moduleSettings.bgColor,
    };
    // 'border': newValue.properties.moduleSettings.contourLine && newValue.properties.moduleSettings.contourLine.show ? newValue.properties.moduleSettings.contourLine.width + 'px solid' + newValue.properties.moduleSettings.contourLine.color : '',
    // 'border-radius': newValue.properties.moduleSettings.contourLine && newValue.properties.moduleSettings.contourLine.show && !newValue.properties.moduleSettings.contourLine.corner ? '6px' : ''};
    this.keyNum++;
    this.$nextTick(() => {
      let width =
        newValue.properties.moduleSettings.typeSetting == 1
          ? 16 + newValue.properties.moduleSettings.leftAndRight
          : 16 + newValue.properties.moduleSettings.leftAndRight - 7;
      let vueWaterfallEasyDom: any = document.querySelector(".vue-waterfall-easy");
      if (vueWaterfallEasyDom) {
        vueWaterfallEasyDom.style.marginLeft = width + "px";
        vueWaterfallEasyDom.style.width = "calc(100% - " + width * 2 + "px)";
        vueWaterfallEasyDom.style.backgroundColor = newValue.properties.moduleSettings.bgColor;
      }
    });
  }

  /**
   * 值发生变化
   * @protected
   * @returns void
   */
  @Watch("currentLocaltion", { immediate: false, deep: true })
  private onLocaltionChange(newValue: any): void {
    // 重新获取区域
    if ((this.data as any).properties.moduleSettings?.moduleIds.includes(1)) {
      this.searchData.areaId = null;
      this.getCityArea();
    }
    // 重新获取产品类型
    if ((this.data as any).properties.moduleSettings?.moduleIds.includes(0)) {
      this.getStoreProductType();
    }
    this.onRefresh(true);
  }

  /**
   * 值发生变化
   * @protected
   * @returns void
   */
  @Watch("searchKey", { immediate: false, deep: true })
  private onSearchKeyChange(newValue: any): void {
    this.onRefresh();
  }

  /**
   * 模块选择
   * @protected
   */
  private moduleObj: any = {
    "0": {
      name: "产品",
      icon: "icon-chanpin",
    },
    "1": {
      name: "机构",
      icon: "icon-a-ziyuan45",
    },
  };

  /**
   * 选中的下标
   * @protected
   */
  private previvewModule: number = 0;

  /**
   * 机构搜索数据
   * @protected
   */
  private searchData: any = {
    areaId: null,
    hospitalType: null,
  };

  /**
   * 机构类型
   * @protected
   */
  private hospitalData: any = [
    { text: "全部", value: null },
    { text: "公立医院", value: 1 },
    { text: "私立医院", value: 2 },
    { text: "专业体检机构", value: 3 },
    { text: "检验机构", value: 4 },
  ];

  /**
   * 区域数据
   * @protected
   */
  private areaData: any = [];

  /**
   * 通过城市拿区域
   * @return Promise<void>
   */
  private async getCityArea(): Promise<any> {
    this.areaData = [{ text: "全部", value: null }];
    let cityName = this.currentLocaltion || this.location?.city;
    if (!cityName) return;
    try {
      let { content: result } = await LocationcityService.instance.getCityArea(cityName);
      if (result.data?.length) {
        result.data.forEach((res) => {
          let json = { text: res.name, value: res.areaId };
          this.areaData.push(json);
        });
      }
    } catch (err) {
      Toast(err);
    }
  }

  /**
   * 机构数据
   * @return Promise<void>
   */
  private hospitalDataList: any = [];

  /**
   * 机构数据页码
   * @return Promise<void>
   */
  private hospitalState: any = {
    pageIndex: 0,
    pageSize: 6,
  };

  /**
   * 机构数据页码
   * @return Promise<void>
   */
  private loadingHospital: boolean = false;

  /**
   * 获取机构数据列表
   */
  protected async loadDataHospital(parameter: any): Promise<any> {
    this.loadingHospital = true;
    let cityName = this.currentLocaltion || this.location?.city;
    try {
      this.hospitalState.pageIndex++;
      parameter = {
        pageIndex: this.hospitalState.pageIndex,
        pageSize: this.hospitalState.pageSize,
        latitude: this.location?.lat,
        longitude: this.location?.lng,
        cityName: cityName,
      };
      let { content: res } = await StoreProductService.instance.hospitalPageList(
        Object.assign(
          this.searchData,
          {
            key: this.searchKey || "",
          },
          parameter
        )
      );
      if (res.data.items?.length) {
        res.data.items.forEach((item) => {
          this.getStoreProduct(item, res.data.totalCount);
        });
      }
      if (res.data.totalCount == 0) {
        this.loadingHospital = false;
        (this.$refs.waterfallHospital as any).waterfallOver();
      }
    } catch (err) {
      Toast(err);
      this.loadingHospital = false;
    }
  }

  protected packageObj: any = {};

  /**
   * 通过机构拿套餐
   * @return Promise<void>
   */
  protected async getStoreProduct(data: any, totalCount: number): Promise<any> {
    try {
      let cityName = this.currentLocaltion || this.location?.city;
      let params = { hospitalId: data.id, cityName: cityName, pageIndex: 1, pageSize: 3 };
      let { content: result } = await StoreProductService.instance.storeProductPageList(params);
      if (result.data?.items?.length) {
        this.packageObj[data.id] = result.data.items || [];
      }
      this.hospitalDataList.push(data);
      setTimeout(() => {
        if (this.hospitalDataList.length == totalCount) {
          (this.$refs.waterfallHospital as any).waterfallOver();
        }
      }, 100);
      this.loadingHospital = false;
    } catch (err) {
      this.loadingHospital = false;
    }
  }
}
